var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","icon":"DollarSignIcon","icon-right":"","statistic":_vm.value,"statisticTitle":"Total Geral","color":"success"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }